import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { incrementItem, decrementItem, removeItem } from "../../Redux/Slice";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";  // Import for redirection

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Hook for redirection
  const { cartItems, cartTotalAmount } = useSelector((state) => state.cart);

  // State for controlling button animation
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleBuyNow = () => {
    setIsRedirecting(true); // Start animation

    // After animation ends, redirect to the payment page
    setTimeout(() => {
      navigate("/payment"); // Redirect to payment page
    }, 1000); // Delay for animation (1 second)
  };

  return (
    <TableContainer component={Paper} sx={{ marginTop: "20px" }}>
      <Table sx={{ minWidth: 650 }} aria-label="cart table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Image</TableCell>
            <TableCell align="center">Item Name</TableCell>
            <TableCell align="center">Quantity</TableCell>
            <TableCell align="center">Price</TableCell>
            <TableCell align="center">Total Price</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cartItems.map((item) => (
            <TableRow key={item.id}>
              <TableCell align="center">
                <img
                  src={item.image}
                  alt={item.title}
                  style={{ width: "100px", height: "100px" }}
                />
              </TableCell>
              <TableCell align="center">{item.title}</TableCell>
              <TableCell align="center">
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => dispatch(decrementItem(item.id))}
                  disabled={item.quantity <= 1}
                >
                  -
                </Button>
                <span style={{ margin: "0 10px" }}>{item.quantity}</span>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => dispatch(incrementItem(item.id))}
                >
                  +
                </Button>
              </TableCell>
              <TableCell align="center">₹{item.description}</TableCell>
              <TableCell align="center">
                ₹{item.quantity * item.description}
              </TableCell>
              <TableCell align="center">
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => dispatch(removeItem(item.id))}
                >
                  Remove
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography
        variant="h6"
        sx={{ marginTop: "10px", textAlign: "right", paddingRight: "20px" }}
      >
        Grand Total: ₹{cartTotalAmount}
      </Typography>

      {/* Buy Now Button with Animation */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleBuyNow}
        sx={{
          marginTop: "20px",
          width: "100%",
          padding: "15px",
          fontSize: "18px",
          transition: "transform 1s ease, opacity 1s ease",
          transform: isRedirecting ? "scale(0)" : "scale(1)",
          opacity: isRedirecting ? 0 : 1,
        }}
      >
        Buy Now
      </Button>
    </TableContainer>
  );
};

export default Cart;
